import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import { sxMicroTimelineDot, sxTimelineConnector, sxTodayMarkerContent } from "./sxProps";

const TodayMarker: React.FC = () => {
  return (
    <TimelineItem sx={{ padding: '0px 14px' }} tabIndex={0}>
      <TimelineSeparator>
        <TimelineConnector sx={sxTimelineConnector} />
        <TimelineDot sx={sxMicroTimelineDot} />
        <TimelineConnector sx={sxTimelineConnector} />
      </TimelineSeparator>
      <TimelineContent sx={sxTodayMarkerContent}>
        <div className='today-marker-line' />
        <div className='today-marker'>
          HOJE
        </div>
      </TimelineContent>
      <TimelineOppositeContent display="none" />
    </TimelineItem>
  );
}

export default TodayMarker;